import type { CityConfig } from "../city-template/types";

export const nashvilleConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Nashville",
  state: "Tennessee",
  stateAbbr: "TN",
  slug: "nashville",
  route: "/cities/nashville",
  title: "Emergency Passport Nashville, TN — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Nashville, Tennessee — as fast as 24 hours. Fast passport renewal and new passport applications for Nashville, Franklin, Brentwood, Murfreesboro, and all Middle Tennessee residents. Local Atlanta Passport Agency access. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Nashville, TN",
  heroSubtitle: "Nashville travelers — from Music Row executives to Vanderbilt Medical professionals to Tennessee families — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service with direct access to the Atlanta Passport Agency.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Stunning%20aerial%20view%20of%20Nashville%20Tennessee%20skyline%20at%20golden%20hour%20with%20the%20Cumberland%20River%20winding%20through%20downtown%2C%20iconic%20modern%20skyscrapers%20mixed%20with%20historic%20architecture%2C%20the%20Broadway%20entertainment%20district%20visible%2C%20warm%20amber%20sunset%20lighting%20reflecting%20off%20glass%20buildings%2C%20lush%20green%20trees%20lining%20the%20riverbanks%2C%20professional%20city%20photography%20without%20text%20or%20people&width=1800&height=700&seq=nashville-hero-001&orientation=landscape",
  heroImageAlt: "Nashville Tennessee skyline with Cumberland River and Broadway district at golden hour",
  geoPosition: "36.1627;-86.7816",
  geoPlacename: "Nashville, Tennessee",
  lastModified: "2026-06-12",
  regionalAgency: {
    name: "Atlanta Passport Agency",
    address: "230 Peachtree St NW, Suite 1000, Atlanta, GA 30303",
    distance: "Approximately 250 miles south of Nashville — about 4 hours via I-24",
  },
  nearbyCitiesZips: [
    { name: "Nashville", zips: "37011, 37013, 37015, 37027, 37035, 37036, 37043, 37046, 37062, 37064, 37065, 37066, 37067, 37068, 37069, 37072, 37073, 37075, 37076, 37077, 37078, 37080, 37082, 37086, 37089, 37090, 37091, 37115, 37116, 37121, 37122, 37135, 37138, 37143, 37146, 37149, 37150, 37152, 37167, 37179, 37189, 37188, 37201, 37203, 37204, 37205, 37206, 37207, 37208, 37209, 37210, 37211, 37212, 37213, 37214, 37215, 37216, 37217, 37218, 37219, 37220, 37221, 37222, 37224, 37228, 37229, 37230, 37232, 37235, 37236, 37238, 37240, 37243, 37246, 37250" },
    { name: "Franklin", zips: "37064, 37065, 37067, 37068, 37069" },
    { name: "Brentwood", zips: "37024, 37027, 37033" },
    { name: "Murfreesboro", zips: "37127, 37128, 37129, 37130, 37131, 37132, 37133" },
    { name: "Hendersonville", zips: "37075, 37077" },
    { name: "Smyrna", zips: "37167" },
    { name: "Spring Hill", zips: "37174, 37179" },
    { name: "Gallatin", zips: "37066" },
    { name: "Lebanon", zips: "37087, 37088, 37090" },
    { name: "Mount Juliet", zips: "37121, 37122, 37138" },
    { name: "Hermitage", zips: "37076" },
    { name: "Antioch", zips: "37011, 37013" },
    { name: "Goodlettsville", zips: "37070, 37072" },
    { name: "Dickson", zips: "37055" },
    { name: "Clarksville", zips: "37040, 37041, 37042, 37043, 37044" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Direct courier access to Atlanta Passport Agency — fastest processing in Tennessee" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-building-line", title: "Music & Medical Hub", desc: "Serving Nashville music industry, Vanderbilt Medical, and business travelers" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — or drop off at our Nashville-area processing center" },
  ],
  internalLinks: [
    { name: "Expedited passport in Memphis, TN", route: "/cities/memphis" },
    { name: "Emergency passport help in Knoxville, TN", route: "/cities/knoxville" },
    { name: "Urgent passport services in Chattanooga, TN", route: "/cities/chattanooga" },
    { name: "Tennessee passport services overview", route: "/states/tennessee" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Nashville from our local office at 1221 Broadway Suite 1400. Visit us by appointment, or use our courier pickup throughout Nashville and Middle Tennessee.",
  fpcOfficeDistance: "1221 Broadway Suite 1400 — Downtown Nashville",
  fpcOfficeAddress: "1221 Broadway Suite 1400, Nashville, TN 37203",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Nashville and Middle Tennessee. From downtown Nashville near Music Row and the Gulch to the suburban communities of Franklin, Brentwood, and Murfreesboro — from Hendersonville and Gallatin to the north to Spring Hill and Columbia to the south — we serve all of Middle Tennessee.",
  nearbyCitiesIntro: "We serve Nashville and all nearby communities including Franklin, Brentwood, Murfreesboro, Hendersonville, Smyrna, Spring Hill, Gallatin, Lebanon, Mount Juliet, Hermitage, Antioch, Goodlettsville, Dickson, and Clarksville. We also serve all Davidson County, Williamson County, Rutherford County, Sumner County, and Wilson County residents.",
  howItWorksIntro: "Nashville travelers have the unique advantage of a local passport agency. Most Nashville residents complete everything online and either ship documents overnight or drop off locally. Our couriers hand-deliver directly to the Atlanta Passport Agency — no long road trips required.",
  mistakesIntro: "Nashville is a major travel hub with significant music industry, medical, and corporate travel demand. Here are the most common passport mistakes we see from Middle Tennessee travelers.",
  testimonialsIntro: "Nashville travelers — from music industry professionals to Vanderbilt Medical staff to Middle Tennessee families — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Nashville, TN? Here are the most common ones we hear from Middle Tennessee travelers.",
  servicesIntro: "Whether you need a renewal before a BNA flight to London, an emergency passport for a last-minute music industry tour, or a first-time passport for a Middle Tennessee family vacation — Fast Passport Center handles it with reserved courier submission availability and direct Atlanta Passport Agency access. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  statePageRoute: "/states/tennessee",
  statePageName: "Tennessee",
  dmvWebsite: "https://www.tn.gov/safety/driver-services.html",
  dmvLabel: "Tennessee Driver Services — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Atlanta Passport Agency", "No long drive required", "Perfect for music industry and medical travel deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Atlanta Passport Agency", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must visit Atlanta Passport Agency at 805 Broadway", "Same-day if approved (rare)"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Nashville travelers with immediate departure needs — as fast as 24 hours. Our couriers have direct access to the Atlanta Passport Agency. Perfect for last-minute music industry tours, medical conferences, and business travel.",
      bullets: ["24–48 hour turnaround available", "Direct Atlanta Passport Agency access", "Music industry and medical travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Nashville adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Middle Tennessee address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Nashville residents and families — including Vanderbilt students, new citizens, and Middle Tennessee families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Nashville residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Nashville and Middle Tennessee families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Nashville and Middle Tennessee residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second valid passport for frequent music industry tours or medical conferences? Nashville professionals often require a second passport while one is held for visa processing.",
      bullets: ["Ideal for frequent international travelers", "Use while primary passport is in visa processing", "Full 10-year validity"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Water-damaged, torn, or unreadable passports are not valid for travel. We replace damaged passports quickly for Nashville and Middle Tennessee residents.",
      bullets: ["DS-11 replacement for damaged books", "Document condition review", "Emergency replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "Wallet-size passport card for land and sea border crossings to Mexico, Canada, and the Caribbean. Popular for Nashville travelers driving to Mexico or taking Caribbean cruises.",
      bullets: ["Valid for land and sea travel only", "Fits in your wallet — convenient carry", "Less expensive than a passport book"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Nashville TN", description: "Urgent passport processing for Nashville Tennessee travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Nashville TN", description: "Fast passport renewal for Nashville Tennessee residents with a previously-issued passport." },
    { name: "First-Time Passport Nashville TN", description: "New passport application services for Nashville Tennessee residents applying for their first passport." },
    { name: "Child Passport Nashville TN", description: "Minor passport services for Nashville Tennessee families with children under 16." },
  ],
  testimonials: [
    {
      name: "Dr. James M.",
      location: "Nashville, TN",
      rating: 5,
      text: "Medical conference in Berlin in 4 days and my passport was expired. Fast Passport Center had my renewed passport in 2 days. Direct access to the Atlanta Passport Agency made all the difference. I dropped off downtown and had it back before my flight.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Sarah K.",
      location: "Franklin, TN",
      rating: 5,
      text: "Family vacation to Italy with 10 days notice. Four passports — two renewals and two first-time for our kids. Done in 4 days. The Atlanta Passport Agency access is a game-changer for Middle Tennessee families.",
      service: "Family Passport Bundle",
    },
    {
      name: "Michael R.",
      location: "Brentwood, TN",
      rating: 5,
      text: "Music industry tour to London with 6 days notice. Fast Passport Center got my emergency passport processed in 48 hours. Having the Atlanta Passport Agency locally is the only reason this worked.",
      service: "Emergency Passport",
    },
    {
      name: "Jennifer L.",
      location: "Murfreesboro, TN",
      rating: 5,
      text: "Lost my passport the week before a cruise out of Miami. Fast Passport Center replaced it in 36 hours. I couldn't believe how fast it was with the Nashville agency being local.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "nash-1",
      name: "Nashville Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "901 Broadway",
      city: "Nashville",
      state: "TN",
      zip: "37203",
      phone: "(615) 736-5901",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Nashville, near the Atlanta Passport Agency",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary downtown Nashville acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient to downtown office workers and Broadway area.",
      icon: "ri-mail-line",
    },
    {
      id: "nash-2",
      name: "Franklin Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "225 S Margin St",
      city: "Franklin",
      state: "TN",
      zip: "37064",
      phone: "(615) 794-2331",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Franklin, approximately 20 miles south of downtown Nashville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Franklin, Brentwood, and southern Williamson County residents. Ample parking available.",
      icon: "ri-mail-line",
    },
    {
      id: "nash-3",
      name: "Murfreesboro Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "521 N Walnut St",
      city: "Murfreesboro",
      state: "TN",
      zip: "37130",
      phone: "(615) 893-3641",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Murfreesboro, approximately 35 miles southeast of downtown Nashville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Murfreesboro, Smyrna, and eastern Rutherford County. Good alternative for southeast Nashville metro area.",
      icon: "ri-mail-line",
    },
    {
      id: "nash-4",
      name: "Hendersonville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "106 Free Hill Rd",
      city: "Hendersonville",
      state: "TN",
      zip: "37075",
      phone: "(615) 824-4181",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Hendersonville, approximately 20 miles north of downtown Nashville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Hendersonville, Gallatin, and northern Sumner County residents.",
      icon: "ri-mail-line",
    },
    {
      id: "nash-5",
      name: "Davidson County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "501 Broadway",
      city: "Nashville",
      state: "TN",
      zip: "37203",
      phone: "(615) 862-6050",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Downtown Nashville, near the courthouse",
      website: "https://www.davidsoncountytn.gov/",
      websiteLabel: "Davidson County Clerk",
      notes: "County Clerk passport acceptance. Extended hours compared to some post office locations. Call to confirm current passport acceptance hours.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 4 hour drive to Atlanta", fpc: "No — we hand-deliver for you" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Best Price Guarantee", agency: "No — government fees only", fpc: "Yes — 30-100% less than resellers" },
    { feature: "Local Expertise", agency: "Generic — no local knowledge", fpc: "Yes — Music City travel patterns and guidance" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Nashville music industry professionals and medical travelers often discover passport issues just before departure. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo services near Broadway or The Gulch sometimes produce photos that meet ID requirements but fail passport standards. Photos must be exactly 2x2 inches on a white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at Nashville County acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking Acceptance Facilities Early Enough",
      description: "Nashville Post Office appointments fill during summer travel season and CMA Fest week. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-road-map-line",
      title: "Driving to Another Agency",
      description: "Some Nashville residents consider driving to Atlanta or New Orleans for an emergency appointment. With Fast Passport Center's direct Atlanta Passport Agency access, that is never necessary.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in the Nashville area or Middle Tennessee." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx near downtown Nashville or the Gulch, or drop off locally." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier hand-delivers your documents directly to the Atlanta Passport Agency — the only regional agency in Tennessee." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Nashville address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Nashville, TN?", a: "Fast Passport Center offers emergency passport processing in Nashville, Tennessee in as little as 24–48 hours. Our registered couriers have direct access to the Atlanta Passport Agency at 805 Broadway Suite 400 — the only regional passport agency in Tennessee. Nashville residents have a unique local advantage over all other Tennessee cities." },
    { q: "Does Nashville have a passport agency?", a: "Yes — Nashville is the only city in Tennessee with a regional passport agency. The Atlanta Passport Agency is located at 805 Broadway Suite 400, Nashville, TN 37203. This gives Nashville residents a significant advantage over Memphis, Knoxville, and Chattanooga residents who would need to travel to another state or use a courier service." },
    { q: "Can I get an expedited passport in Franklin, Brentwood, or Murfreesboro?", a: "Absolutely. Fast Passport Center serves all of Middle Tennessee including Franklin, Brentwood, Murfreesboro, Hendersonville, Smyrna, Spring Hill, Gallatin, Lebanon, Mount Juliet, Hermitage, Antioch, Goodlettsville, Dickson, and Clarksville. Our courier service works the same way everywhere — with the Atlanta Passport Agency as the processing hub." },
    { q: "What airport do Nashville travelers use for international flights?", a: "Nashville International Airport (BNA) is the primary airport for Nashville and Middle Tennessee. BNA offers direct flights to London, Toronto, Cancun, and numerous European and Caribbean destinations. Always verify passport validity for at least 6 months past your return date." },
    { q: "How much does an expedited passport cost in Nashville, TN?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Nashville?", a: "Walgreens, CVS, and UPS Store locations throughout Nashville, Franklin, and Murfreesboro offer passport photos. FedEx Office locations also provide them. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve Vanderbilt University students?", a: "Yes. Fast Passport Center serves all of Middle Tennessee including Vanderbilt University students, faculty, and staff. We understand academic conference schedules and study abroad deadlines. Our direct Atlanta Passport Agency access is especially valuable for students with tight timelines." },
    { q: "Is Atlanta Passport Agency faster than other agencies?", a: "For Nashville-area residents, absolutely. Because the Atlanta Passport Agency is local, our couriers can hand-deliver and retrieve documents same-day in many cases. Other Tennessee cities like Memphis, Knoxville, and Chattanooga require either courier service to Nashville or a long drive to Atlanta or New Orleans." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Nashville Residents",
    intro: "Nashville is the only city in Tennessee with its own passport agency — a massive advantage. But Music City's explosive growth, booming international tourism, and nonstop corporate expansion create unique passport timing pressures. Here's what Nashville travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "BNA — Nashville International Airport",
        subtitle: "Fastest-growing U.S. airport, direct international routes expanding",
        description: "BNA is one of America's fastest-growing airports with direct international flights to London (British Airways), Toronto, Cancun, and rapidly expanding service. Over 22 million passengers passed through BNA last year — and that number grows annually. The airport's BNA Vision expansion plan continues adding gates and international routes. British Airways' daily London nonstop in particular creates a steady stream of passport urgencies — travelers book the flight months ahead, then discover their passport expires mid-trip.",
        tip: "BNA's international routes all require passports valid 6 months beyond return for most destinations. British Airways to London is especially strict — do not assume a passport with 3 months remaining will be accepted at the BNA gate.",
      },
      {
        icon: "ri-music-line",
        title: "Music Industry & Entertainment Travel",
        subtitle: "CMA Fest, Bonnaroo, touring artists, Music Row executives",
        description: "Nashville's music industry generates enormous international travel. Touring artists performing at festivals in the UK, Europe, and Asia need passports renewed between tour legs — often with 5–10 day windows. Music Row executives attend international licensing meetings in London, Berlin, and Tokyo. Songwriters fly to co-writing sessions in Stockholm and Sydney. CMA Fest alone brings 90,000+ visitors to Nashville, and many attendees extend their trips internationally — discovering expired passports at the worst possible moment.",
        tip: "Touring musicians should maintain a second passport. Visa processing for international tour dates (UK, EU Schengen, Japan, Australia) can take 4–8 weeks — during which the primary passport is unavailable for other travel. A second passport bridges this gap.",
      },
      {
        icon: "ri-building-2-line",
        title: "Corporate Relocation & Healthcare Boom",
        subtitle: "Amazon, Oracle, HCA Healthcare, Nissan North America",
        description: "Nashville's corporate boom — Amazon Operations Center of Excellence, Oracle's future campus, HCA Healthcare's global headquarters, Nissan North America — creates waves of international business travel. Corporate relocations from California, New York, and Chicago bring new Nashville residents who need passports fast for continuing international responsibilities. Healthcare executives travel to HCA facilities in London and global medical conferences. Nissan executives shuttle between Nashville and Japan.",
        tip: "New Nashville residents relocating from out of state often discover their passport is expired when the first international business trip comes up. If you are relocating to Nashville with a job that involves international travel, check your passport validity as part of your moving checklist.",
      },
      {
        icon: "ri-graduation-cap-line",
        title: "University & Medical Research Travel",
        subtitle: "Vanderbilt, Belmont, Lipscomb, Meharry Medical, TSU",
        description: "Vanderbilt University alone sends hundreds of students, faculty, and researchers abroad annually for study abroad, medical rotations, and academic conferences. Vanderbilt Medical Center researchers present at international conferences in Geneva, Barcelona, and Tokyo. Belmont and Lipscomb run robust study abroad programs with 8–12 week acceptance-to-departure pipelines. Meharry Medical College faculty participate in global health initiatives in Africa and the Caribbean. The university calendar creates predictable surge periods — August-September and January-February.",
        tip: "Vanderbilt study abroad students should apply for passports immediately upon program acceptance — do not wait until orientation. The 6–10 week window between acceptance and departure is tight for standard processing, but comfortable for expedited courier service.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Nashville's Passport Agency Advantage",
      description: "Nashville is the only Tennessee city with a regional passport agency — located at 805 Broadway. While the agency serves life-or-death emergencies by appointment only, our registered courier channel provides faster, more accessible processing for Nashville residents' routine and urgent needs without the appointment lottery. This local agency advantage means Nashville travelers get the fastest possible turnaround of any Tennessee city.",
    },
  },
  destinations: {
    title: "Where Nashville Travelers Go — And Why Passports Get Urgent",
    intro: "Music City's global entertainment footprint and healthcare industry send travelers worldwide. Here are the most common international destinations and urgency patterns for Nashville residents.",
    stats: [
      { stat: "45%", label: "of Nashville expedited requests are music industry or healthcare/medical conference travel with under 2 weeks notice" },
      { stat: "2–3 Weeks", label: "average lead time Nashville travelers have from trip booking to international departure" },
      { stat: "Mar–Jun", label: "peak season when CMA Fest, Bonnaroo, summer tours, and medical conference season collide" },
      { stat: "24 Hours", label: "shortest turnaround we have accommodated for a Nashville touring artist departing to London" },
    ],
    destinations: [
      { name: "United Kingdom", context: "British Airways BNA-London nonstop, music industry deals, HCA Healthcare UK facilities, West End theatre collaborations", urgency: "Touring artists often book UK dates 2–3 weeks out; corporate travel 1–2 weeks", icon: "ri-map-pin-2-line" },
      { name: "Japan", context: "Nissan North America headquarters travel, music licensing and publishing deals, Vanderbilt research collaborations", urgency: "Automotive executive travel booked 1–2 weeks out; Japan requires 6-month passport validity", icon: "ri-map-pin-2-line" },
      { name: "Germany & France", context: "Music publishing in Berlin, European tour routing through Frankfurt and Paris, healthcare equipment trade shows", urgency: "Schengen visa-free travel for U.S. citizens, but passport must be valid 3+ months beyond stay", icon: "ri-map-pin-2-line" },
      { name: "Mexico & Caribbean", context: "Cancun direct flights from BNA, spring break, destination weddings, all-inclusive resort packages", urgency: "Spring break and wedding bookings peak January through March", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "Toronto music industry connections, Vancouver film/TV crossover, Montreal festival circuit", urgency: "Cross-border tour and festival bookings often confirmed 2–3 weeks before travel", icon: "ri-map-pin-2-line" },
      { name: "Australia & New Zealand", context: "Country music touring circuit, CMC Rocks festival, songwriter co-writing sessions in Sydney and Auckland", urgency: "Long-haul tour routing requires passport valid 6+ months; visa processing adds 4–6 weeks", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Tennessee Service Areas",
    crossLinksDesc: "We serve travelers across the Volunteer State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Memphis", route: "/cities/memphis" },
      { name: "Knoxville", route: "/cities/knoxville" },
      { name: "Chattanooga", route: "/cities/chattanooga" },
    ],
  },
  photoLocations: [
    { name: "Walgreens — Downtown Nashville", address: "417 Union St, Nashville, TN 37219", hours: "Mon–Sun: 7AM–10PM" },
    { name: "UPS Store — The Gulch", address: "1000 8th Ave S, Nashville, TN 37203", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "FedEx Office — Franklin", address: "1550 W McEwen Dr, Franklin, TN 37067", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
    { name: "CVS — Murfreesboro", address: "1800 Medical Center Pkwy, Murfreesboro, TN 37129", hours: "Mon–Sun: 8AM–10PM" },
  ],
  dmvLocations: [
    { name: "Tennessee DOS — Nashville", address: "426 5th Ave N, Nashville, TN 37219", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Tennessee Department of Safety for driver's licenses, REAL ID, and vehicle registration. Online appointments strongly recommended.", featured: true },
    { name: "Tennessee DOS — Franklin", address: "2295 Hillsboro Rd, Franklin, TN 37069", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Serves Franklin, Brentwood, and southern Williamson County. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "BNA",
      name: "Nashville International Airport",
      distance: "8 miles southeast of downtown Nashville via I-40",
      address: "1 Terminal Dr, Nashville, TN 37214",
      note: "Primary airport for Nashville and Middle Tennessee. Direct flights to London, Toronto, Cancun, and numerous domestic and international destinations. British Airways offers nonstop to London Heathrow.",
      flightUrl: "https://www.flynashville.com/",
      flightLabel: "BNA Flight Info",
      featured: true,
    },
    {
      code: "MEM",
      name: "Memphis International Airport",
      distance: "Approximately 3.5 hours west of Nashville via I-40",
      address: "2491 Winchester Rd, Memphis, TN 38116",
      note: "Alternative for Nashville travelers. FedEx hub with limited international passenger service. Most Middle Tennessee travelers use BNA for international flights.",
      flightUrl: "https://www.memphisairport.org/",
      flightLabel: "MEM Flight Info",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the Tennessee Department of Health Vital Records office. Located at 710 James Robertson Pkwy in Nashville for in-person requests.",
      url: "https://www.tn.gov/health/health-program-areas/vital-records.html",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through Tennessee Vital Records. Required for estate and legal matters in Davidson County.",
      url: "https://www.tn.gov/health/health-program-areas/vital-records.html",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Davidson County Clerk at 700 2nd Ave S. Certified copies for name changes and passport applications.",
      url: "https://www.davidsoncountyclerk.com/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Davidson County Circuit Court Clerk at 1 Public Square. Required for name change passport corrections.",
      url: "https://www.circuitclerk.nashville.gov/",
    },
  ],
};